<template>
    <div>
        <span class="coupon-label">
            {{ $t('coupon.address') }}
        </span>
        <span>{{ placeAddress }}</span>
    </div>
</template>

<script>
export default {
    name: 'coupon-address',
    props: {
        place: { type: Object, required: true },
    },
    computed: {
        /**
         * Returns appointment's place address
         */
        placeAddress() {
            return this.place
                ? this.place.formattedAddress
                : null;
        },
    },
};
</script>

<style lang="scss" scoped>

</style>
